import React, { Component } from 'react';
import{
    Container,
    Col,
    Row,
    Button,
    Modal,
    ModalBody
} from 'reactstrap';
import {withRouter} from 'react-router-dom';
import { UtentiData } from '../components/Utenti/UtentiData';
import { UtentiList } from '../components/Utenti/UtentiList';


/**
 * Used for the Listino Prezzi section. 
 */
class UtentiContainer extends Component {

    constructor(props) {
        super(props);

        this.toggleUtenteModal = this.toggleUtenteModal.bind(this);

        this.state = {
            utenti: [],
            availableRoles: [],
            availableAgenti: [],
            utenteModal: false,
            error: "", 
            edit: false,
            utente: null,
            userName: "",
            email: "",
            nome: "",
            cognome: "",
            password: "",
            verificaPassword: "",
            agenteId: "Seleziona un Agente Id",
            agente: null,
            roles: [],
            selectedRole: "Seleziona un ruolo",
        };
    
    }

    componentDidMount() {
        this.getUtenti();
        this.getRoles();
        this.getAgenti();
    }


    getUtenti = () => {
        fetch(`/api/users`, {   
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            console.log(myjson)
            this.setState({
                utenti: myjson.users,
            })
        }).catch(e => {

        });
    }

    getRoles = () => {
        fetch(`/api/roles`, {   
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            console.log(myjson)
            this.setState({
                availableRoles: myjson,
            })
        }).catch(e => {

        });
    }
  
    getAgenti = () => {
        fetch(`/api/agenti`, {   
            method: 'GET',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            this.setState({
                availableAgenti: myjson
            });
        }).catch(e => {
            console.log(e)
        });
    }

    toggleUtenteModal = () => {
        if(this.state.utenteModal){
            this.setState({
                utenteModal: !this.state.utenteModal,
                edit: false,
                userName: "",
                email: "",
                nome: "",
                cognome: "",
                password: "",
                verificaPassword: "",
                roles: [],
                agenteId: "Seleziona un Agente Id",
                selectedRole: "Seleziona un ruolo",
            })
        }
        else{
            this.setState({
                utenteModal: !this.state.utenteModal
            })
        }
        
    }

    handleRoleSelect = (role) => {
        this.setState({
            selectedRole: role.name
        })
    }

    handleAgenteSelect = (agente) => {
        this.setState({
            agente: agente,
            agenteId: agente.nominativo
        })
    }

    handleFilterChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }, console.log(`${e.target.name} is ${e.target.value}`))
    }

    handleDelete = (utente, index) => {
        fetch(`/api/deleteUser/${utente.userId}`, {   
            method: 'DELETE',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Changes the response to an object
        }).then(response => {
            if(response.status === 404){
                throw new Error("User does not exist")
            }
            else if(response.status === 500){
                throw new Error("Error: User not deleted")
            }

            this.getUtenti();
        }).catch(e => {
            console.log(e)
        });
    }

    editUtente = (utente) => {
        this.setState({
            utente: utente,
            userName: utente.userName,
            email: utente.email,
            nome: utente.nome,
            cognome: utente.cognome,
            password: "",
            verificaPassword: "",
            agenteId: utente.agenteId ? utente.agenteId : this.state.agenteId,
            selectedRole: utente.roles[0],
            edit: true
        }, () => this.toggleUtenteModal());
    }

    dataValid = () => {
        if(!this.state.userName || this.state.userName === ""){
            this.setState({
                error: "Controlla nome utenti e riprova"
            })

            return false;
        }
        else if(!this.state.email || !this.state.email.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)){
            this.setState({
                error: "Controlla email e riprova"
            })

            return false;
        }
        else if(!this.state.nome || this.state.nome === ""){
            this.setState({
                error: "Controlla nome e riprova"
            })

            return false;
        }
        else if(!this.state.cognome || this.state.cognome === ""){
            this.setState({
                error: "Controlla cognome e riprova"
            })

            return false;
        }
        else if((!this.state.password || this.state.password === "") && !this.state.edit){
            this.setState({
                error: "Controlla la password e riprova"
            })

            return false;
        }
        else if(this.state.password !== this.state.verificaPassword){
            this.setState({
                error: "Le passwords non corrispondono"
            })

            return false;
        }
        else if(!this.state.selectedRole || this.state.selectedRole === "Seleziona un ruolo"){
            this.setState({
                error: "Controlla ruolo e riprova"
            })

            return false;
        }
        else if((!this.state.agenteId || this.state.agenteId === "") && this.state.selectedRole === "Agenti"){
            this.setState({
                error: "Controlla Agente Id e riprova"
            })

            return false;
        }
        

        return true
    }

    submitForm = () => {
        if(this.dataValid()){
            var url = `/api/createUser`;

            const form = {
                userName: this.state.userName,
                email: this.state.email,
                nome: this.state.nome,
                cognome: this.state.cognome,
                password: this.state.password,
                agenteId: this.state.agente ? this.state.agente.codice : "",
                roles: [this.state.selectedRole],
            }

            if(this.state.edit){
                url = `/api/editUser`;
                form.id = this.state.utente.userId;
            }

            fetch(url, {   
                method: 'POST',
                headers: new Headers({
                    //Authorization token
                    'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                    //Sets the content type. Necessary for the server to recognize the information
                    'Content-Type': 'application/json' 
                }),
                //Sets the body of the call
                body: JSON.stringify(form)
                //Changes the response to an object
            }).then(response => {
                if(response.status !== 204){
                    throw new Error(`Error: ${response.status}`)
                }

                this.toggleUtenteModal();

                this.getUtenti();
            })
            .catch(e => {
                console.log(e)
            });
        }        
    }
    /**
     * Renders the page
     */
    render() {

        return (
            <Container fluid style={{color: "#011e41"}}>  
                <Container className="d-flex align-items-center" fluid>
                    <Row className="d-flex justify-content-center align-items-center" style={{width: "100vw", margin: "0px", padding: "0px"}}>
                        <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", borderBottom: "1px solid #011e41", marginTop: "10px"}}>
                            <Button type="button" className="text-center" onClick={this.toggleUtenteModal} style={{width: '50%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px"}}>
                                Aggiungi un nuovo utente
                            </Button>                                    
                        </Col>
                    </Row> 
                </Container>
                <UtentiList 
                    utenti={this.state.utenti}
                    editFun={this.editUtente}
                    handleDelete={this.handleDelete}
                />         
                <Modal size="xl" isOpen={this.state.utenteModal} toggle={this.toggleUtenteModal} style={{fontSize: "22px", color: "#011e41"}}>
                    <ModalBody>
                        <UtentiData 
                            edit={this.state.edit} 
                            error={this.state.error}
                            userName={this.state.userName}
                            email={this.state.email}
                            nome={this.state.nome}
                            cognome={this.state.cognome}
                            password={this.state.password}
                            verificaPassword={this.state.passwordVerify}
                            roles={this.state.availableRoles}  
                            agenti={this.state.availableAgenti}
                            agenteId={this.state.agenteId}  
                            selectedRole={this.state.selectedRole}
                            handleRoleSelect={this.handleRoleSelect}
                            handleAgenteSelect={this.handleAgenteSelect}
                            handleFilterChange={this.handleFilterChange}
                            submitForm={this.submitForm}
                        />
                    </ModalBody>
                </Modal>
            </Container>
        )
    }
}

export default withRouter(UtentiContainer)


// WEBPACK FOOTER //
// ./src/containers/UtentiContainer.js